/** Manual request status change (Helpdesk role). */
export interface ManualStatusChangeRequest {
  requestId: number;
  newStatusId?: number;
  sourceStatusHistoryId?: number;
  description: string;
}

export const createManualStatusChangeRequest = (requestId: number): ManualStatusChangeRequest => ({
  requestId: requestId,
  newStatusId: undefined,
  sourceStatusHistoryId: undefined,
  description: "",
});
